import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { enumText, translate, isNullOrEmpty, getUserNameToName, formatData, enumColor } from '../../../../../utils/util';
import { ENUMS, PERMISSIONS } from '../../../../../utils/constants';
import { checkPermission } from '../../../../../services/auth';
import { connect } from 'react-redux';
import { getVision } from '../../../../../services/auth';
import { VISIONS } from '../../../../../utils/constants';

const LinePickingListItemOrder = (props) => {
    const manageOrder = checkPermission(PERMISSIONS.Lowering.Access);
    const getStatus = (value) => translate(`expedition:${enumText(ENUMS.eOrderStatus, value)}`);
    const getStatusAlertRoute = (value) => enumColor(ENUMS.eTypeAlert, value);

    const getOrderCode = (orderGroupId, orderCode, orderItems) => {
        if (orderGroupId !== undefined && orderGroupId !== null) {
            return `${orderGroupId} - ${orderCode}`;
        }
        else if (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) {
            let orderItemCode = orderItems && orderItems.length > 0 ? orderItems[0].orderItemCode : "";
            if (orderItems && orderItems.length > 1) {
                const filterOrderItem = orderItems.find(o => o.status !== ENUMS.eOrderItemStatus.Canceled.value
                    && o.status !== ENUMS.eOrderItemStatus.Repicking.value
                    && o.status !== ENUMS.eOrderItemStatus.Finished.value)

                orderItemCode = filterOrderItem ? filterOrderItem.orderItemCode : orderItems[0].orderItemCode
            }
            return `${orderCode} - ${orderItemCode}`
        }

        return `${orderCode}`;
    };

    const orderItemsConfirmed = () => {
        if (!props.data.items) {
            return false;
        }
        const total = props.data.items.filter((i) => {
            return i.status !== ENUMS.eOrderItemStatus.Repicking.value
        }).length;
        const itemsWaitingAndInProgress = props.data.items.filter((i) => {
            return i.status === ENUMS.eOrderItemStatus.Waiting.value || i.status === ENUMS.eOrderItemStatus.InProgress.value;
        }).length;
        return ((total - itemsWaitingAndInProgress) > 0);
    };

    const totalItems = () => {
        if (!props.data.items || props.report) {
            return '';
        }
        const total = props.data.items.length;
        const totalWaiting = props.data.items.filter((i) => i.status === ENUMS.eOrderItemStatus.Waiting.value).length;
        return `${(totalWaiting)}/${total}`;
    };

    const checkRepicking = () => {
        if (!props.data.items) {
            return '';
        }

        const waitingRepicking = props.data.items.filter((i) => i.status === ENUMS.eOrderItemStatus.WaitingRepicking.value).length === 1;
        if (waitingRepicking) {
            return translate(`expedition:${ENUMS.eOrderItemStatus.WaitingRepicking.text}`);
        }

        return '';
    };

    const sendPrinter = () => {
        if (props.sendPrinter) {
            props.sendPrinter([props.data?.orderId], false);
        }
    }

    const renderItems = () => {
        return (<>

            {(getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) &&
                (props.data.status !== ENUMS.eOrderStatus.Canceled.value) && (
                    <>
                        <span className="title sixth-text-color">
                            {(props.data?.items[0]?.partnumber)}
                        </span>
                        <div className="col s12 " style={{ padding: '0px' }}>
                            <span className="title sixth-text-color">
                                {props.data?.items[0]?.location}
                            </span>
                        </div>
                        <div className="col s12 " style={{ padding: '0px' }}>
                            <span className="title sixth-text-color">
                                {getOrderCode(props.data.orderGroupId, props.data.orderCode, props.data?.items)}
                            </span>
                        </div>
                        <div className="col s12 " style={{ padding: '0px' }}>
                            <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                {translate('line-picking:linepicking.amount')}: {(props.data?.items[0]?.quantity)}
                            </span>

                        </div>
                        <div className="col s12 " style={{ padding: '0px' }}>
                            <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                {translate('line-picking:linepicking.mdr')}:  {props.data.items[0]?.mdrType}
                            </span>
                        </div>
                        <div className="col s12 " style={{ padding: '0px' }}>
                            <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                {translate('delivery:fields.pdu')}:  {props.data.items[0]?.locationTarget}
                            </span>
                            <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                {translate('delivery:fields.destination')}:  {props.data.items[0]?.destination}
                            </span>
                        </div>
                        <div className="col s12 " style={{ padding: '0px' }}>
                            <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                {translate('physical-confirmation:date')}:  {formatData(props.data.date)}
                            </span>
                        </div>
                        <div className="col s12 " style={{ padding: '0px' }}>
                            <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                {translate('physical-confirmation:cim')}:  {props.data.items[0]?.cim}
                            </span>
                        </div>

                    </>
                )}
            {getVision() !== VISIONS.Fiasa && (
                <span className="title sixth-text-color">{getOrderCode(props.data.orderGroupId,
                    props.data.orderCode, props.data?.items)} </span>
            )}
            {
                props.data.orderGroupId !== undefined && (
                    <span className="truncate second-text-color" style={{ marginLeft: '10px' }} >
                        {`${formatData(props.data?.orderGroup?.createdOn) || ''}`}
                    </span>)
            }
            {
                props.filter.partnumber !== undefined && (
                    <span className="truncate second-text-color" style={{ marginLeft: '10px' }} >
                        {`${props.data?.items[0]?.nextLocation || ''}`}
                    </span>)
            }
            {
                props.data.type !== ENUMS.eOrderType.Picking.value &&
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }} >
                    <div className="col s12 " style={{ padding: '0px' }}>
                        {translate('line-picking:linepicking.route')}: {props.data.route?.code}
                    </div>
                </span>
            }

            <div className="col s12 " style={{ padding: '0px' }}>
                {
                    (props.data.status !== ENUMS.eOrderStatus.Canceled.value) ? (
                        <span className="truncate second-text-color" style={{ marginLeft: '10px', padding: '0px' }}>
                            <small>{getStatus(props.data.status)} | <b>{totalItems()}</b></small>
                        </span>
                    ) : (
                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                            <small>{getStatus(props.data.status)}</small>
                        </span>)
                }
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    {manageOrder === true && !isNullOrEmpty(props.data.startedBy) ? `${getUserNameToName(props?.usersFromElog, props.data.startedBy)}` : ''}
                </span>
                {
                    !isNullOrEmpty(checkRepicking()) && (
                        <span className="truncate red-text" style={{ marginLeft: '10px', display: 'flex' }}>
                            <i className="material-icons">error_outline</i> {checkRepicking()}
                        </span>
                    )
                }
                {
                    (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) && props.data.status === ENUMS.eOrderStatus.OnHold.value && (
                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                            {manageOrder && !isNullOrEmpty(props.data.updateBy) ?
                                `${getUserNameToName(props?.usersFromElog, props.data.updateBy)}`
                                : ''}  | <b>{props.data.waitCounter}</b>
                        </span>)
                }
                {
                    (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) && props.data.status === ENUMS.eOrderStatus.NotFound.value && (
                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                            <b>{formatData(props.data.updateOn)}</b>
                        </span>)
                }
                {
                    !isNullOrEmpty(props.data?.items[0]?.observation) && (
                        <span className="truncate red-text" style={{ marginLeft: '10px' }}>
                            <b>{props.data?.items[0]?.observation}</b>
                        </span>)
                }
                {
                    props.data.type === ENUMS.eOrderType.Picking.value &&
                    <div>
                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }} >
                            <div className="col s12 " style={{ padding: '0px' }}>
                                {translate('expedition:picking.supplier')}: {props.data.supplierCode} - {props.data.supplierName}
                            </div>
                        </span>
                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }} >
                            <div className="col s12 " style={{ padding: '0px' }}>
                                {translate('expedition:picking.invoice')}: {props.data.nf}
                            </div>
                        </span>
                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }} >
                            <div className="col s12 " style={{ padding: '0px' }}>
                                {translate('general:status')} NF: {props.data.statusNF}
                            </div>
                        </span>
                    </div>

                }
            </div>
        </>)
    }

    return (
        <>
            {
                !props.report && manageOrder && (props.data.status === ENUMS.eOrderStatus.InProgress.value || props.data.status === ENUMS.eOrderStatus.Waiting.value || props.data.status === ENUMS.eOrderStatus.WaitingRouteComposition.value
                    || props.data.status === ENUMS.eOrderStatus.OnHold.value || ENUMS.eOrderStatus.WaitingRouteInformation.value) && (
                    <>
                        {!orderItemsConfirmed() && !props.report && (
                            <span
                                className="title sixth-text-color right"
                                style={{ position: 'absolute', marginTop: '5px', right: '10px', zIndex: '999' }}
                                onClick={(event) => {
                                    event.preventDefault();
                                    if (props.onClickUnlonckOrder) {
                                        props.onClickUnlonckOrder(event, props.data);
                                    }
                                }}
                            ><i className="material-icons">lock_open</i>
                            </span>
                        )}
                        <span
                            className="title sixth-text-color right"
                            style={{ position: 'absolute', marginTop: '5px', right: '45px', zIndex: '999' }}
                            onClick={(event) => {
                                event.preventDefault();
                                if (props.onClickUserTransfer) {
                                    props.onClickUserTransfer(event, props.data);
                                }
                            }}
                        ><i className="material-icons">contacts</i>
                        </span>
                        {(getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) &&
                            <span
                                className="title sixth-text-color right"
                                style={{ position: 'absolute', marginTop: '40px', right: '45px', zIndex: '999' }}
                                onClick={(event) => {
                                    event.preventDefault();
                                    if (props.data.status !== ENUMS.eOrderStatus.OnHold.value) {
                                        if (props.onClickPutOnHold) {
                                            props.onClickPutOnHold(event, props.data);
                                        }
                                    }
                                    else {
                                        if (props.onPutOnPlay) {
                                            props.onPutOnPlay(event, props.data);
                                        }

                                    }


                                }}
                            ><i className="material-icons">{props.data.status !== ENUMS.eOrderStatus.OnHold.value ? "pause_circle_outline" : "play_arrow"}</i>
                            </span>
                        }
                        {
                            props.checkPrint &&
                            <span
                                className="title sixth-text-color right"
                                style={{ position: 'absolute', marginTop: '40px', right: '10px', zIndex: '999' }}
                                onClick={sendPrinter}
                            ><i className="material-icons">local_printshop</i>
                            </span>
                        }
                        {
                            props.data.typeAlert &&
                            <span
                                className="title sixth-text-color right"
                                style={{ position: 'absolute', marginTop: '100px', right: '10px', zIndex: '999' }}
                            ><i className="mdi mdi-circle" style={{ color: getStatusAlertRoute(props.data.typeAlert) }} />
                            </span>
                        }
                    </>
                )
            }
            {
                !props.report ? (
                    <Link
                        className="row"
                        style={{ display: 'block', marginBottom: '0px' }}
                        to={props.route}
                        onClick={(event) => {
                            if (props.onSelectChange && !props.report) {
                                props.onSelectChange(event);
                            }
                        }} >
                        {renderItems()}
                    </Link>) : (
                    <div
                        className="row"
                        style={{ display: 'block', marginBottom: '0px' }}>
                        {renderItems()}
                    </div>
                )
            }
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.loweringReducer.filter,
        usersFromElog: state.usersElogReducer.usersElog,
        user: state.userReducer.user
    };
};

export default withRouter(connect(mapStateToProps)(withTranslation()(LinePickingListItemOrder)));
